import type * as Types from '../generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SetThemeAndLayoutMutationVariables = Types.Exact<{
  payload: Types.SetThemeAndLayoutPayload;
}>;

export type SetThemeAndLayoutMutation = {
  __typename?: 'Mutation';
  setThemeAndLayout: {
    __typename?: 'EventDesign';
    id: string;
    hasUnpublishedChanges: boolean;
    brannanNavigation: Types.BrannanNavigation;
    websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType };
    activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
    theme: { __typename?: 'Theme'; id: string; themeId: string };
  };
};

export type SetBrannanInnerFrameBorderPreferenceMutationVariables = Types.Exact<{
  payload: Types.DesignPreferenceBooleanInput;
}>;

export type SetBrannanInnerFrameBorderPreferenceMutation = {
  __typename?: 'Mutation';
  setBrannanInnerFrameBorder: { __typename?: 'EventDesign'; id: string; hasUnpublishedChanges: boolean };
};

export type SetBrannanBackgroundTransparencyPreferenceMutationVariables = Types.Exact<{
  payload: Types.DesignPreferenceRangeInput;
}>;

export type SetBrannanBackgroundTransparencyPreferenceMutation = {
  __typename?: 'Mutation';
  setBrannanBackgroundTransparency: { __typename?: 'EventDesign'; id: string; hasUnpublishedChanges: boolean };
};

export type SetAccentMutationVariables = Types.Exact<{
  payload: Types.SetAccentPayload;
}>;

export type SetAccentMutation = { __typename?: 'Mutation'; setAccent: { __typename?: 'EventDesign'; id: string; accent?: string | null } };

export type SetCustomCssMutationVariables = Types.Exact<{
  payload: Types.SetCustomCssPayload;
}>;

export type SetCustomCssMutation = { __typename?: 'Mutation'; setCustomCss: { __typename?: 'EventDesign'; id: string; customCss: string } };

export type SetFontMutationVariables = Types.Exact<{
  payload: Types.SetFontPayload;
}>;

export type SetFontMutation = {
  __typename?: 'Mutation';
  setFont: { __typename?: 'EventDesign'; id: string; hasUnpublishedChanges: boolean; font: { __typename?: 'Font'; id: string } };
};

export type PublishEventDesignDraftMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type PublishEventDesignDraftMutation = {
  __typename?: 'Mutation';
  publishEventDesignDraft: {
    __typename?: 'EventDesign';
    id: string;
    hasUnpublishedChanges: boolean;
    hasVisitedDesignPage?: boolean | null;
    guestSiteTarget: Types.GuestSiteTargetEnum;
    brannanNavigation: Types.BrannanNavigation;
    useCustomTheme: boolean;
    accent?: string | null;
    customCss: string;
    mapStyle?: Types.EventDesignMapStyle | null;
    linkAndButtonColor?: string | null;
    artFontColor?: string | null;
    artBackgroundColor?: string | null;
    pageBackgroundColor?: string | null;
    pageFontColor?: string | null;
    websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType; name: string };
    font: { __typename?: 'Font'; id: string; display: string; fontFamily: string; textTransform: Types.FontWeight };
    fonts?: Array<{
      __typename?: 'FontPackConfiguration';
      id: string;
      category: Types.Category;
      size?: number | null;
      sizePercent?: number | null;
      font?: { __typename?: 'Font'; id: string; fontFamily: string; fontSize: number; fontWeight: number; firebaseFontKey: string } | null;
    }> | null;
    theme: {
      __typename?: 'Theme';
      id: string;
      themeId: string;
      name: string;
      colorSchemes: Array<{ __typename?: 'ThemeColorScheme'; id: string; colors: Array<{ __typename?: 'Color'; hex: string; isLight: boolean }> }>;
      designLayouts: Array<{ __typename?: 'DesignLayout'; id: string }>;
      websiteLayoutBrannanSettings?: {
        __typename?: 'WebsiteLayoutBrannanSettings';
        brannanBackgroundTransparency?: {
          __typename?: 'DesignPreferenceRange';
          supportsCustomization: boolean;
          id: string;
          featureName: string;
          featureValueType: Types.FeatureValueType;
          rangeValue: number;
          rangeMax: number;
          rangeMin: number;
          rangeStep: number;
        } | null;
      } | null;
      websiteLayoutAlohaSettings?: {
        __typename?: 'WebsiteLayoutAlohaSettings';
        alohaColorPreference?: {
          __typename?: 'DesignPreferenceColor';
          id: string;
          featureName: string;
          featureValueType: Types.FeatureValueType;
          supportsCustomization: boolean;
          colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
        } | null;
        alohaTextColorPreference?: {
          __typename?: 'DesignPreferenceColor';
          id: string;
          featureName: string;
          featureValueType: Types.FeatureValueType;
          supportsCustomization: boolean;
          colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
        } | null;
      } | null;
    };
    masthead: { __typename?: 'EventDesignMasthead'; id?: string | null; isEnabled: boolean };
    colorPalette: Array<{ __typename?: 'ColorSet'; id: string; color: { __typename?: 'Color'; hex: string; isLight: boolean } }>;
    activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
    customTheme?: {
      __typename?: 'CustomTheme';
      id: string;
      desktopThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
      mobileThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
    } | null;
    designPreferences: Array<
      | {
          __typename?: 'EventDesignPreferenceBoolean';
          id: string;
          featureId: string;
          featureName: string;
          featureType: Types.DesignFeatureType;
          featureValueType: Types.FeatureValueType;
          booleanValue: boolean;
        }
      | {
          __typename?: 'EventDesignPreferenceColorPointer';
          id: string;
          featureName: string;
          featureType: Types.DesignFeatureType;
          colorPointer?: number | null;
          colorPointerPosition?: Types.ColorPointerLocation | null;
        }
      | {
          __typename?: 'EventDesignPreferenceRange';
          id: string;
          featureId: string;
          featureName: string;
          featureType: Types.DesignFeatureType;
          featureValueType: Types.FeatureValueType;
          rangeValue: number;
        }
    >;
  };
};

export type SetHasVisitedDesignPageMutationVariables = Types.Exact<{
  payload: Types.SetHasVisitedDesignPagePayload;
}>;

export type SetHasVisitedDesignPageMutation = {
  __typename?: 'Mutation';
  setHasVisitedDesignPage: { __typename?: 'EventDesign'; id: string; hasUnpublishedChanges: boolean; hasVisitedDesignPage?: boolean | null };
};

export type SetPresetTemplateMutationVariables = Types.Exact<{
  themeAndLayoutPayload: Types.SetThemeAndLayoutPayload;
  fontPayload: Types.SetFontPayload;
}>;

export type SetPresetTemplateMutation = {
  __typename?: 'Mutation';
  setThemeAndLayout: {
    __typename?: 'EventDesign';
    id: string;
    hasUnpublishedChanges: boolean;
    websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType };
    theme: { __typename?: 'Theme'; id: string; themeId: string };
  };
  setFont: { __typename?: 'EventDesign'; id: string; hasUnpublishedChanges: boolean; font: { __typename?: 'Font'; id: string } };
};

export const SetThemeAndLayoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetThemeAndLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetThemeAndLayoutPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setThemeAndLayout' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'theme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetThemeAndLayoutMutationFn = Apollo.MutationFunction<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>;

/**
 * __useSetThemeAndLayoutMutation__
 *
 * To run a mutation, you first call `useSetThemeAndLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetThemeAndLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setThemeAndLayoutMutation, { data, loading, error }] = useSetThemeAndLayoutMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetThemeAndLayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>) {
  return ApolloReactHooks.useMutation<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>(SetThemeAndLayoutDocument, baseOptions);
}
export type SetThemeAndLayoutMutationHookResult = ReturnType<typeof useSetThemeAndLayoutMutation>;
export type SetThemeAndLayoutMutationResult = Apollo.MutationResult<SetThemeAndLayoutMutation>;
export type SetThemeAndLayoutMutationOptions = Apollo.BaseMutationOptions<SetThemeAndLayoutMutation, SetThemeAndLayoutMutationVariables>;
export const SetBrannanInnerFrameBorderPreferenceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBrannanInnerFrameBorderPreference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceBooleanInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBrannanInnerFrameBorder' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetBrannanInnerFrameBorderPreferenceMutationFn = Apollo.MutationFunction<
  SetBrannanInnerFrameBorderPreferenceMutation,
  SetBrannanInnerFrameBorderPreferenceMutationVariables
>;

/**
 * __useSetBrannanInnerFrameBorderPreferenceMutation__
 *
 * To run a mutation, you first call `useSetBrannanInnerFrameBorderPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrannanInnerFrameBorderPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrannanInnerFrameBorderPreferenceMutation, { data, loading, error }] = useSetBrannanInnerFrameBorderPreferenceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetBrannanInnerFrameBorderPreferenceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetBrannanInnerFrameBorderPreferenceMutation, SetBrannanInnerFrameBorderPreferenceMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetBrannanInnerFrameBorderPreferenceMutation, SetBrannanInnerFrameBorderPreferenceMutationVariables>(
    SetBrannanInnerFrameBorderPreferenceDocument,
    baseOptions,
  );
}
export type SetBrannanInnerFrameBorderPreferenceMutationHookResult = ReturnType<typeof useSetBrannanInnerFrameBorderPreferenceMutation>;
export type SetBrannanInnerFrameBorderPreferenceMutationResult = Apollo.MutationResult<SetBrannanInnerFrameBorderPreferenceMutation>;
export type SetBrannanInnerFrameBorderPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetBrannanInnerFrameBorderPreferenceMutation,
  SetBrannanInnerFrameBorderPreferenceMutationVariables
>;
export const SetBrannanBackgroundTransparencyPreferenceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBrannanBackgroundTransparencyPreference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceRangeInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBrannanBackgroundTransparency' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetBrannanBackgroundTransparencyPreferenceMutationFn = Apollo.MutationFunction<
  SetBrannanBackgroundTransparencyPreferenceMutation,
  SetBrannanBackgroundTransparencyPreferenceMutationVariables
>;

/**
 * __useSetBrannanBackgroundTransparencyPreferenceMutation__
 *
 * To run a mutation, you first call `useSetBrannanBackgroundTransparencyPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBrannanBackgroundTransparencyPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBrannanBackgroundTransparencyPreferenceMutation, { data, loading, error }] = useSetBrannanBackgroundTransparencyPreferenceMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetBrannanBackgroundTransparencyPreferenceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetBrannanBackgroundTransparencyPreferenceMutation, SetBrannanBackgroundTransparencyPreferenceMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetBrannanBackgroundTransparencyPreferenceMutation, SetBrannanBackgroundTransparencyPreferenceMutationVariables>(
    SetBrannanBackgroundTransparencyPreferenceDocument,
    baseOptions,
  );
}
export type SetBrannanBackgroundTransparencyPreferenceMutationHookResult = ReturnType<typeof useSetBrannanBackgroundTransparencyPreferenceMutation>;
export type SetBrannanBackgroundTransparencyPreferenceMutationResult = Apollo.MutationResult<SetBrannanBackgroundTransparencyPreferenceMutation>;
export type SetBrannanBackgroundTransparencyPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetBrannanBackgroundTransparencyPreferenceMutation,
  SetBrannanBackgroundTransparencyPreferenceMutationVariables
>;
export const SetAccentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAccent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetAccentPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAccent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accent' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetAccentMutationFn = Apollo.MutationFunction<SetAccentMutation, SetAccentMutationVariables>;

/**
 * __useSetAccentMutation__
 *
 * To run a mutation, you first call `useSetAccentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccentMutation, { data, loading, error }] = useSetAccentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetAccentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAccentMutation, SetAccentMutationVariables>) {
  return ApolloReactHooks.useMutation<SetAccentMutation, SetAccentMutationVariables>(SetAccentDocument, baseOptions);
}
export type SetAccentMutationHookResult = ReturnType<typeof useSetAccentMutation>;
export type SetAccentMutationResult = Apollo.MutationResult<SetAccentMutation>;
export type SetAccentMutationOptions = Apollo.BaseMutationOptions<SetAccentMutation, SetAccentMutationVariables>;
export const SetCustomCssDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCustomCss' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetCustomCssPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCustomCss' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customCss' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetCustomCssMutationFn = Apollo.MutationFunction<SetCustomCssMutation, SetCustomCssMutationVariables>;

/**
 * __useSetCustomCssMutation__
 *
 * To run a mutation, you first call `useSetCustomCssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomCssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomCssMutation, { data, loading, error }] = useSetCustomCssMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetCustomCssMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCustomCssMutation, SetCustomCssMutationVariables>) {
  return ApolloReactHooks.useMutation<SetCustomCssMutation, SetCustomCssMutationVariables>(SetCustomCssDocument, baseOptions);
}
export type SetCustomCssMutationHookResult = ReturnType<typeof useSetCustomCssMutation>;
export type SetCustomCssMutationResult = Apollo.MutationResult<SetCustomCssMutation>;
export type SetCustomCssMutationOptions = Apollo.BaseMutationOptions<SetCustomCssMutation, SetCustomCssMutationVariables>;
export const SetFontDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetFont' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetFontPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFont' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetFontMutationFn = Apollo.MutationFunction<SetFontMutation, SetFontMutationVariables>;

/**
 * __useSetFontMutation__
 *
 * To run a mutation, you first call `useSetFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFontMutation, { data, loading, error }] = useSetFontMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetFontMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetFontMutation, SetFontMutationVariables>) {
  return ApolloReactHooks.useMutation<SetFontMutation, SetFontMutationVariables>(SetFontDocument, baseOptions);
}
export type SetFontMutationHookResult = ReturnType<typeof useSetFontMutation>;
export type SetFontMutationResult = Apollo.MutationResult<SetFontMutation>;
export type SetFontMutationOptions = Apollo.BaseMutationOptions<SetFontMutation, SetFontMutationVariables>;
export const PublishEventDesignDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PublishEventDesignDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishEventDesignDraft' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesign' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesign' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVisitedDesignPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestSiteTarget' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'font' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'textTransform' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fonts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firebaseFontKey' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizePercent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'theme' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorSchemes' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeColorScheme' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'designLayouts' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutBrannanSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brannanBackgroundTransparency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutAlohaSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaTextColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'accent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'masthead' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customCss' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mapStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorPalette' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ColorSet' } }] },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteEventColors' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTheme' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTheme' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'designPreferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ThemeColorScheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemeColorScheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Color' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Color' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceColor' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceColor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ColorSet' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ColorSet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteEventColors' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointerPosition' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'booleanValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PublishEventDesignDraftMutationFn = Apollo.MutationFunction<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>;

/**
 * __usePublishEventDesignDraftMutation__
 *
 * To run a mutation, you first call `usePublishEventDesignDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventDesignDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventDesignDraftMutation, { data, loading, error }] = usePublishEventDesignDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishEventDesignDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>(PublishEventDesignDraftDocument, baseOptions);
}
export type PublishEventDesignDraftMutationHookResult = ReturnType<typeof usePublishEventDesignDraftMutation>;
export type PublishEventDesignDraftMutationResult = Apollo.MutationResult<PublishEventDesignDraftMutation>;
export type PublishEventDesignDraftMutationOptions = Apollo.BaseMutationOptions<PublishEventDesignDraftMutation, PublishEventDesignDraftMutationVariables>;
export const SetHasVisitedDesignPageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetHasVisitedDesignPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetHasVisitedDesignPagePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setHasVisitedDesignPage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasVisitedDesignPage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetHasVisitedDesignPageMutationFn = Apollo.MutationFunction<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>;

/**
 * __useSetHasVisitedDesignPageMutation__
 *
 * To run a mutation, you first call `useSetHasVisitedDesignPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHasVisitedDesignPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHasVisitedDesignPageMutation, { data, loading, error }] = useSetHasVisitedDesignPageMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetHasVisitedDesignPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>) {
  return ApolloReactHooks.useMutation<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>(SetHasVisitedDesignPageDocument, baseOptions);
}
export type SetHasVisitedDesignPageMutationHookResult = ReturnType<typeof useSetHasVisitedDesignPageMutation>;
export type SetHasVisitedDesignPageMutationResult = Apollo.MutationResult<SetHasVisitedDesignPageMutation>;
export type SetHasVisitedDesignPageMutationOptions = Apollo.BaseMutationOptions<SetHasVisitedDesignPageMutation, SetHasVisitedDesignPageMutationVariables>;
export const SetPresetTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetPresetTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'themeAndLayoutPayload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetThemeAndLayoutPayload' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fontPayload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetFontPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setThemeAndLayout' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'themeAndLayoutPayload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'theme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFont' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fontPayload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetPresetTemplateMutationFn = Apollo.MutationFunction<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>;

/**
 * __useSetPresetTemplateMutation__
 *
 * To run a mutation, you first call `useSetPresetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPresetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPresetTemplateMutation, { data, loading, error }] = useSetPresetTemplateMutation({
 *   variables: {
 *      themeAndLayoutPayload: // value for 'themeAndLayoutPayload'
 *      fontPayload: // value for 'fontPayload'
 *   },
 * });
 */
export function useSetPresetTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>) {
  return ApolloReactHooks.useMutation<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>(SetPresetTemplateDocument, baseOptions);
}
export type SetPresetTemplateMutationHookResult = ReturnType<typeof useSetPresetTemplateMutation>;
export type SetPresetTemplateMutationResult = Apollo.MutationResult<SetPresetTemplateMutation>;
export type SetPresetTemplateMutationOptions = Apollo.BaseMutationOptions<SetPresetTemplateMutation, SetPresetTemplateMutationVariables>;
